/*
fetch wrapper, djangoCSRFToken global variable is required
*/

const djangoFetch = (
  url,
  init = {},
  getCSRFToken = () =>
    document.querySelector('meta[name="csrf"]').getAttribute('content'),
) => {
  let headers;
  init = { ...init, mode: 'cors' };
  if (init.headers == undefined) {
    headers = {};
  } else {
    headers = { ...init.headers };
  }
  headers = {
    ...headers,
    'X-CSRFToken': getCSRFToken(),
    'X-Requested-With': 'XMLHttpRequest',
  };
  return fetch(url, { ...init, headers });
};

/*
body transformation helper function when Content-Type is application/x-www-form-urlencoded
*/
export const objectToQueryString = paramObject => {
  return Object.keys(paramObject)
    .map(
      key =>
        `${encodeURIComponent(key)}=${encodeURIComponent(paramObject[key])}`,
    )
    .join('&');
};

export const formDataToQueryString = formData => {
  return Array.from(formData.entries())
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
    )
    .join('&');
};

export const formDataToJson = formData => {
  const formDataJson = {};
  for (let [key,value] of formData.entries()) {
    if (formDataJson.hasOwnProperty(key)) {
      if (Array.isArray(formDataJson[key])) {
        formDataJson[key].push(value);
      } else {
        formDataJson[key] = [formDataJson[key], value];
      }
    } else {
      formDataJson[key] = value;
    }
  }
  //return JSON.stringify(formDataJson);
  return formDataJson;
};

export default djangoFetch;



// WEBPACK FOOTER //
// ./src/js/lib/fetch/djangoFetch.js